export type UserPermissionsState = {
  permissions: string[],
}

export const initialUserPermissions: UserPermissionsState = {
  permissions: [], // Array to store permissions
};
